import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../src/taskpane/redux";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { ContentManagerCopyMoveModeEnum } from "../../../src/taskpane/components/enums/ContentManagerCopyMoveModeEnum";

export function useMenuItem_Error(setIsCMUploadFilesPanelOpen: (isCMUploadFilesPanelOpen: boolean) => void, setIsCMMoveFilesListPanelOpen: (isCMMoveFilesListPanelOpen: boolean) => void) {
    const languageStrings = React.useContext(LanguageContext);
    
    const errorMessages = useSelector((state: RootState) => state.savingInBackground.errorMessages);  
    const exchangeProgress = useSelector((state: RootState) => state.contentManagerDirectory.exchange.progress);
    const moveToMode = useSelector((state: RootState) => state.contentManagerDirectory.moveTo.mode);

    const [menuItem_Error, setMenuItem_Error] = React.useState<IContextualMenuItem>();

    React.useEffect(() => {
        if (errorMessages?.length > 0) {
            setMenuItem_Error(
                {
                    key: "errorMessage",
                    text: `${languageStrings.ErrorMessageGeneric}`,
                    iconProps: { iconName: "Error" },
                    onClick: () => {
                        if ((exchangeProgress && exchangeProgress.status) || moveToMode === ContentManagerCopyMoveModeEnum.CopyEntireFolderEmails) {
                            setIsCMMoveFilesListPanelOpen(true);
                        } else {
                            setIsCMUploadFilesPanelOpen(true);
                        }
                    }
                }
            )
        } else {
            setMenuItem_Error(null)
        }
    }, [errorMessages, exchangeProgress, moveToMode])

    return {
        menuItem_Error
    }

}